import * as actions from './actions'

const profesorStore = {
  namespaced: true,
  actions,
}

export default profesorStore